/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  Box,
  Button,
  Stack,
  TextField,
  // InputAdornment,
  IconButton,
  Grid,
  Tooltip,
  TextareaAutosize,
  InputAdornment,
  Select,
  MenuItem,
  Snackbar,
  Alert,
} from "@common-ui/ui";
// import { orderBy } from "lodash";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Edit, Groups, Info, Place } from "@mui/icons-material";
// import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import UploadFileIcon from '@mui/icons-material/UploadFile';
import ImageIcon from '@mui/icons-material/Image';
import EditIcon from '@mui/icons-material/Edit';

import { createAsset, updateAssetDetails, updateAssetImage, putAssetImage } from "../../services";
import { Avatar, Divider, Typography } from "@mui/material";

import { validateAssetID, validateImageType } from "../../utils";
const INFO = {
  assetID: `The unique Asset Identifier as assigned for your Organization.`,
  make: `The Manufacturer, Make, or Brand that made the device. Usually as displayed on the product tag or front panel.`,
  model: `The Model Number, Catalog ID, or Product Code that identifies the product.`,
  description: `The Description, Nomenclature, or Name of the device. Usually as printed on the product tag or front panel.`,
  options: `Any options, add-ons, or upgrades installed or enabled for the product.`,
  oemSerialNumber: `The serial Number or ID assigned by the Manufacturer of the product. Select non-serialized if no serial number is present.
  Select illegible if present but unreadable.`,
  customSerialNumber: `A custom serial number assigned by the Owner or Client. Different from the Asset ID.`,
  // secondarySerialNumber: ``,
  secondaryAssetID: `The Asset Identifier as assigned by the Owner or Client. Different from the Asset ID.`,
  assetName: `A name to help identify the Asset. Defaults to Asset ID, Make, Model, Description. You can create any name you like, for example: High Capacity Pump #7`,
  comment: ``,
};

const BUTTONS = {
  ADD_BUTTON: {"label": "Add Image", "variant": "contained", "icon": <UploadFileIcon />, "size": "medium" },
  EDIT_BUTTON: {"label": "", "variant": "text", "icon": <EditIcon />, "size": "small" }
};

const org = window?.localStorage?.getItem("REDUX_CURRENT_ORGANIZATION");
const orgID = (org) ? JSON.parse(org) : undefined;

export const CompleteAssetDialog = ({
  open,
  handleClose,
  handleCreate,
  customer,
  clientData,
  currentOrgId,
  newPlaceParent,
  newCustomer,
  setOpenCreateDialog,
  name,
  ...props
}) => {
  const [isMake, setIsMake] = useState("KNOWN");
  const [isModel, setIsModel] = useState("KNOWN");
  const [isSerialNumber, setIsSerialNumber] = useState("SERIALIZED");

  const [toast, setToast] = useState([]);
  const imageReader = new FileReader();
  const [assetImageBtnProps, setAssetImageBtnProps] = useState(BUTTONS.ADD_BUTTON);
  const [assetImageUrl, setAssetImageUrl] = useState("");
  const [assetImageFileType, setAssetImageFileType] = useState("");

  const [openDialog, setOpenDialog] = React.useState(false);
  const assetImageInputRef = useRef(null);

  useEffect(() => {
    setToast([]);
    return () => { };
  }, []);

  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  const formik = useFormik({
    initialValues: {
      assetID: "",
      make: "",
      model: "",
      description: "",
      options: "",
      oemSerialNumber: "",
      customSerialNumber: "",
      secondaryAssetID: "",
      assetName: "",
      comments: ""
    },
    validationSchema: Yup.object({
      assetID: Yup.string()
        .trim()
        .test(
          "custom-asset-id-validation",
          "Please enter a valid Asset ID. I Must be uppercase, and lowercase and some special characters.",
          function (value) {
            return validateAssetID(value);
          }
        )
        .required("Asset ID is required"),
      make: Yup.string().trim().required("Make is required"),
      model: Yup.string().trim().required("Model is required"),
      description: Yup.string().trim().required("Description is required"),
      options: Yup.string().trim(),
      oemSerialNumber: Yup.string()
        .trim()
        .required("OEM Serial Number is required"),
      customSerialNumber: Yup.string().trim(),
      secondaryAssetID: Yup.string().trim(),
      assetName: Yup.string()
        .trim()
        .required("Asset Name / Nick Name is required"),
      comments: Yup.string().trim(),
    }),
    onSubmit: () => {
      async function submit() {
        let {
          assetID,
          make,
          model,
          description,
          options,
          oemSerialNumber,
          customSerialNumber,
          secondaryAssetID,
          assetName,
          comments,
        } = formik.values;
        const attributes = {
          customer: newCustomer
            ? newCustomer.system_id
              ? newCustomer.system_id
              : newCustomer.id
            : null,
          place: newPlaceParent ? newPlaceParent?.system_id : null,
          id: assetID,
          secondary_id: secondaryAssetID,
          product_type: null,
          make: make,
          make_custom: isMake === "CUSTOM" ? true : false,
          model: model,
          model_custom: isModel === "CUSTOM" ? true : false,
          options: options,
          serial_number: oemSerialNumber,
          non_serialized: isSerialNumber === "NON_SERIALIZED" ? true : false,
          custom_serial_number: customSerialNumber,
          name: assetName,
          description: description,
          disposition: null,
          notes: comments,
          image_type: assetImageFileType.split("/")[1],
          attributes: [],
        };
        try {
          const { payload } = await onSubmit(attributes);
          //Upload the image once asset submit the data
          await submitAssetImage(payload);
          props.init();
          // console.log("payload", payload, attributes);
          setToast([
            ...toast,
            {
              message: "Success",
              open: true,
              severity: "success",
            },
          ]);
          handleClickOpen(payload);
          setTimeout(() => {
            formik.resetForm();

            handleClose();
          }, 1000);
        } catch (error) {
          if (error.message === "Request failed with status code 405") {
            setToast([
              ...toast,
              {
                message: `Asset ID ${assetID} already exists.`,
                open: true,
                severity: "error",
              },
            ]);
          } else {
            setToast([
              ...toast,
              {
                message: error.message,
                open: true,
                severity: "error",
              },
            ]);
          }
          formik.setSubmitting(false);
        }
      }
      submit();
    },
  });

  const handleClickOpen = (id = -1) => {
    // setAssetID(id);
    setOpenDialog(true);
  };
  // eslint-disable-next-line no-unused-vars
  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
  const onSubmit = async (attributes) => {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      try {
        const payload = await createAsset(attributes, orgID?.id);

        resolve({ payload: payload?.system_id });
      } catch (error) {
        reject(error);
      }
    });
  };

  useEffect(() => {
    formik.setFieldValue(
      "assetName",
      `${formik.values.make} ${formik.values.model} ${formik.values.description} ${formik.values.assetID}`
    );
  }, [
    formik.values.make,
    formik.values.model,
    formik.values.description,
    formik.values.assetID,
  ]);

  const handleImageSelection = async (file) => {
    if (!file || !validateImageType(file)) {
      setToast([
        ...toast,
        {
          message: `Please upload valid images. Allowed types: jpeg, jpg, webp, png, and svg`,
          open: true,
          severity: "error",
        },
      ]);
      return false;
    }
    imageReader.onloadend = () => {
      setAssetImageUrl(imageReader.result);
    }
    imageReader.readAsDataURL(file);
    setAssetImageFileType(file?.type);
    setAssetImageBtnProps(BUTTONS.EDIT_BUTTON);
    return true;
  }
  const removeAssetImage = () => {
    setAssetImageUrl("");
    setAssetImageFileType("");
    setAssetImageBtnProps(BUTTONS.ADD_BUTTON);
  };

  const submitAssetImage = async (id, file) => {
    try {
      file = file || assetImageInputRef.current.files[0];
      const image_type = file.type.split("/")[1];
      const response = await updateAssetImage(orgID?.id, id, image_type);
      
      if (response.status === 200 && response.data.putUrl) {
        const res = await putAssetImage(response.data.putUrl, file, image_type);
        if (res.status === 200) {
          removeAssetImage();
        }
      }
    } catch (error) {
      setToast([
        ...toast,
        {
          message: error,
          open: true,
          severity: "error",
        },
      ]);
    }
  };
  
  return (
    <div>
      <Dialog
        open={open}
        onClose={() => {
          handleClose();
        }}
        aria-labelledby="alert-dialog-name"
        aria-describedby="alert-dialog-description"
        scroll="paper"
        fullWidth={true}
        maxWidth="xlg"
      >
        <>
          <DialogTitle sx={{ px: 2 }} id="alert-dialog-title" scroll="paper">
            <Stack sx={{ alignItems: "left" }}>
              <Typography fontSize={18} variant="h4">
                Complete Asset Information
              </Typography>
            </Stack>
            {open ? (
              <IconButton
                aria-label="close"
                onClick={() => {
                  handleClose();
                }}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
            ) : null}
          </DialogTitle>
          <Divider />
          <DialogContent sx={{ px: 2 }}>
            <Box component="main">
              {/* Owner*/}
              <Grid container spacing={2}>
                <Grid item xs={12} md={3}>
                  <Typography fontSize={18} variant="h4">
                    Owner:
                  </Typography>
                </Grid>
                <Grid item xs={12} md={3}>
                  <Typography fontSize={12} fontWeight={700}>
                    Owner
                  </Typography>
                  <TextField
                    disabled
                    autoComplete="off"
                    size="small"
                    value={newCustomer?.name}
                    fullWidth
                    placeholder="Type"
                    margin="normal"
                    sx={{ mt: "8px" }}
                    name="owner"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Groups />
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="edit owner"
                            onClick={() => {
                              // setCustomer(null);
                              setOpenCreateDialog();
                            }}
                            onMouseDown={(event) => {
                              event.preventDefault();
                            }}
                            edge="end"
                          >
                            <Edit />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <Typography fontSize={12} fontWeight={700}>
                    Place
                  </Typography>
                  <TextField
                    disabled
                    autoComplete="off"
                    size="small"
                    fullWidth
                    value={newPlaceParent?.name}
                    placeholder="None"
                    margin="normal"
                    sx={{ mt: "8px" }}
                    name="place"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Place />
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="edit owner"
                            onClick={() => {
                              setOpenCreateDialog();
                            }}
                            onMouseDown={(event) => {
                              event.preventDefault();
                            }}
                            edge="end"
                          >
                            <Edit />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={3}></Grid>
              </Grid>
              <Divider sx={{ my: 2 }} />
              {/* Asset Details: */}
              <Grid container spacing={2}>
                <Grid item xs={12} md={3}>
                  <Typography fontSize={18} variant="h4">
                    Asset Details:
                  </Typography>
                </Grid>
                <Grid item xs={12} md={3}>
                  <Stack direction="row" justifyContent="space-between">
                    <Typography fontSize={12} variant="h4" fontWeight="700">
                      Asset ID *
                    </Typography>
                    <span>
                      <Tooltip placement="right" title={INFO.assetID}>
                        <Info
                          sx={{
                            fontSize: 16,
                            color: (theme) => theme.palette.grey[500],
                          }}
                        />
                      </Tooltip>
                    </span>
                  </Stack>
                  <TextField
                    autoComplete="off"
                    size="small"
                    error={Boolean(
                      formik.touched.assetID && formik.errors.assetID
                    )}
                    fullWidth
                    helperText={formik.touched.assetID && formik.errors.assetID}
                    placeholder="Type"
                    margin="normal"
                    sx={{ mt: "8px" }}
                    name="assetID"
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    value={formik.values.assetID}
                  />
                </Grid>

                <Grid item xs={12} md={3}>
                  <Stack direction="row" justifyContent="space-between">
                    <Typography fontSize={12} variant="h4" fontWeight="700">
                      OEM Serial Number *
                    </Typography>
                    <span>
                      <Tooltip placement="right" title={INFO.oemSerialNumber}>
                        <Info
                          sx={{
                            fontSize: 16,
                            color: (theme) => theme.palette.grey[500],
                          }}
                        />
                      </Tooltip>
                    </span>
                  </Stack>
                  <Stack direction="row">
                    <TextField
                      autoComplete="off"
                      disabled={isSerialNumber !== "SERIALIZED" ? true : false}
                      size="small"
                      error={Boolean(
                        formik.touched.oemSerialNumber &&
                        formik.errors.oemSerialNumber
                      )}
                      fullWidth
                      helperText={
                        formik.touched.oemSerialNumber &&
                        formik.errors.oemSerialNumber
                      }
                      placeholder="Type"
                      margin="normal"
                      sx={{ mt: "8px" }}
                      name="oemSerialNumber"
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      value={formik.values.oemSerialNumber}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment sx={{ pl: 0 }} position="start">
                            {" "}
                            <Select
                              sx={{
                                my: "8px",
                                ml: "-14px",
                                backgroundColor: (theme) =>
                                  theme.palette.grey[100],
                              }}
                              onChange={(event) => {
                                const value = event.target.value;
                                if (value === "NON_SERIALIZED") {
                                  formik.setFieldValue(
                                    "oemSerialNumber",
                                    "Non-Serialized"
                                  );
                                } else if (value === "ILLEGIBLE") {
                                  formik.setFieldValue(
                                    "oemSerialNumber",
                                    "Illegible"
                                  );
                                } else {
                                  formik.setFieldValue("oemSerialNumber", "");
                                }
                                setIsSerialNumber(value);
                              }}
                              size="small"
                              placeholder="Select"
                              name="oem-type"
                              variant="outlined"
                              value={isSerialNumber}
                              defaultValue="SERIALIZED"
                            >
                              <MenuItem value="SERIALIZED">Serialized</MenuItem>
                              <MenuItem value="NON_SERIALIZED">
                                Non-Serialized
                              </MenuItem>
                              <MenuItem value="ILLEGIBLE">Illegible</MenuItem>
                            </Select>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Stack>
                </Grid>
                <Grid item xs={12} md={3}>
                  <Stack direction="row" justifyContent="space-between">
                    <Typography fontSize={12} variant="h4" fontWeight="700">
                      Custom Serial Number
                    </Typography>
                    <span>
                      <Tooltip
                        placement="right"
                        title={INFO.customSerialNumber}
                      >
                        <Info
                          sx={{
                            fontSize: 16,
                            color: (theme) => theme.palette.grey[500],
                          }}
                        />
                      </Tooltip>
                    </span>
                  </Stack>
                  <TextField
                    autoComplete="off"
                    size="small"
                    error={Boolean(
                      formik.touched.customSerialNumber &&
                      formik.errors.customSerialNumber
                    )}
                    fullWidth
                    helperText={
                      formik.touched.customSerialNumber &&
                      formik.errors.customSerialNumber
                    }
                    placeholder="Type"
                    margin="normal"
                    sx={{ mt: "8px" }}
                    name="customSerialNumber"
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    value={formik.values.customSerialNumber}
                  />
                </Grid>

                <Grid item xs={12} md={3}>
                  <Stack direction="row" justifyContent="center">
                    {assetImageUrl && assetImageUrl.length > 0 ? (
                      <img
                        alt={formik.values.assetName}
                        src={assetImageUrl}
                        style={{
                          height: "6.5rem",
                          objectFit: "contain",
                        }}
                      />
                    ) : (
                      <IconButton
                        onClick={() => assetImageInputRef.current.click()}
                      >
                        <Avatar sx={{ bgcolor: '#BADBFF' }}>
                          <ImageIcon color="primary" fontSize="small" />
                        </Avatar>
                      </IconButton>
                    )
                    }
                  </Stack>
                </Grid>
                <Grid item xs={12} md={3}>
                  <Stack direction="row" justifyContent="space-between">
                    <Typography fontSize={12} variant="h4" fontWeight="700">
                      Make *
                    </Typography>
                    <span>
                      <Tooltip placement="right" title={INFO.make}>
                        <Info
                          sx={{
                            fontSize: 16,
                            color: (theme) => theme.palette.grey[500],
                          }}
                        />
                      </Tooltip>
                    </span>
                  </Stack>
                  <Stack direction="row">
                    <TextField
                      autoComplete="off"
                      disabled={isMake === "UNKNOWN" ? true : false}
                      size="small"
                      error={Boolean(formik.touched.make && formik.errors.make)}
                      fullWidth
                      helperText={formik.touched.make && formik.errors.make}
                      placeholder="Type"
                      margin="normal"
                      sx={{ mt: "8px", paddingLeft: "0px !important" }}
                      name="make"
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      value={formik.values.make}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment sx={{ pl: 0 }} position="start">
                            <Select
                              sx={{
                                my: "8px",
                                ml: "-14px",
                                pl: 0,
                                backgroundColor: (theme) =>
                                  theme.palette.grey[100],
                              }}
                              onChange={(event) => {
                                const value = event.target.value;
                                console.log("Value", value);
                                if (value === "UNKNOWN") {
                                  formik.setFieldValue("make", "Unknown");
                                } else {
                                  formik.setFieldValue("make", "");
                                }
                                setIsMake(value);
                              }}
                              size="small"
                              placeholder="Select"
                              name="make-type"
                              variant="outlined"
                              value={isMake}
                              defaultValue="KNOWN"
                            >
                              <MenuItem value="KNOWN">Known</MenuItem>
                              <MenuItem value="UNKNOWN">Unknown</MenuItem>
                              <MenuItem value="CUSTOM">Custom</MenuItem>
                            </Select>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Stack>
                </Grid>
                <Grid item xs={12} md={3}>
                  <Stack direction="row" justifyContent="space-between">
                    <Typography fontSize={12} variant="h4" fontWeight="700">
                      Model *
                    </Typography>
                    <span>
                      <Tooltip placement="right" title={INFO.model}>
                        <Info
                          sx={{
                            fontSize: 16,
                            color: (theme) => theme.palette.grey[500],
                          }}
                        />
                      </Tooltip>
                    </span>
                  </Stack>
                  <Stack direction="row">
                    <TextField
                      autoComplete="off"
                      disabled={isModel === "UNKNOWN" ? true : false}
                      size="small"
                      error={Boolean(
                        formik.touched.model && formik.errors.model
                      )}
                      fullWidth
                      helperText={formik.touched.model && formik.errors.model}
                      placeholder="Type"
                      margin="normal"
                      sx={{ mt: "8px" }}
                      name="model"
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      value={formik.values.model}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment sx={{ pl: 0 }} position="start">
                            {" "}
                            <Select
                              sx={{
                                my: "8px",
                                ml: "-14px",
                                backgroundColor: (theme) =>
                                  theme.palette.grey[100],
                              }}
                              onChange={(event) => {
                                const value = event.target.value;
                                if (value === "UNKNOWN") {
                                  formik.setFieldValue("model", "Unknown");
                                } else {
                                  formik.setFieldValue("model", "");
                                }
                                setIsModel(value);
                              }}
                              size="small"
                              placeholder="Select"
                              name="model-type"
                              variant="outlined"
                              value={isModel}
                              defaultValue="KNOWN"
                            >
                              <MenuItem value="KNOWN">Known</MenuItem>
                              <MenuItem value="UNKNOWN">Unknown</MenuItem>
                              <MenuItem value="CUSTOM">Custom</MenuItem>
                            </Select>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Stack>
                </Grid>

                <Grid item xs={12} md={3}>
                  <Stack direction="row" justifyContent="space-between">
                    <Typography fontSize={12} variant="h4" fontWeight="700">
                      Description *
                    </Typography>
                    <span>
                      <Tooltip placement="right" title={INFO.description}>
                        <Info
                          sx={{
                            fontSize: 16,
                            color: (theme) => theme.palette.grey[500],
                          }}
                        />
                      </Tooltip>
                    </span>
                  </Stack>
                  <TextField
                    autoComplete="off"
                    size="small"
                    error={Boolean(
                      formik.touched.description && formik.errors.description
                    )}
                    fullWidth
                    helperText={
                      formik.touched.description && formik.errors.description
                    }
                    placeholder="Type"
                    margin="normal"
                    sx={{ mt: "8px" }}
                    name="description"
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    value={formik.values.description}
                  />
                </Grid>

                <Grid item xs={12} md={3}>
                  <Stack direction="row" justifyContent="center">
                    <Button
                      variant={assetImageBtnProps.variant}
                      color="primary"
                      size={assetImageBtnProps.size}
                      onClick={() => assetImageInputRef.current.click()}
                      startIcon={assetImageBtnProps.icon}
                    >
                      {assetImageBtnProps.label}
                      <input
                        name="image_url"
                        ref={assetImageInputRef}
                        multiple={false}
                        style={{ display: "none" }}
                        type="file"
                        accept="image/*"
                        onChange={() =>
                          handleImageSelection(assetImageInputRef.current.files[0])
                        }
                        value={formik.values.image_url}
                      />
                    </Button>
                    {assetImageUrl && assetImageUrl.length > 0 && (
                      <Button
                        size="small"
                        variant="text"
                        onClick={removeAssetImage}
                        startIcon={<CloseIcon />}
                      >
                      </Button>
                    )}
                  </Stack>
                </Grid>

                <Grid item xs={12} md={3}>
                  <Stack direction="row" justifyContent="space-between">
                    <Typography fontSize={12} variant="h4" fontWeight="700">
                      Options
                    </Typography>
                    <span>
                      <Tooltip placement="right" title={INFO.options}>
                        <Info
                          sx={{
                            fontSize: 16,
                            color: (theme) => theme.palette.grey[500],
                          }}
                        />
                      </Tooltip>
                    </span>
                  </Stack>
                  <TextField
                    autoComplete="off"
                    size="small"
                    error={Boolean(
                      formik.touched.options && formik.errors.options
                    )}
                    fullWidth
                    helperText={formik.touched.options && formik.errors.options}
                    placeholder="Type"
                    margin="normal"
                    sx={{ mt: "8px" }}
                    name="options"
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    value={formik.values.options}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <Stack direction="row" justifyContent="space-between">
                    <Typography fontSize={12} variant="h4" fontWeight="700">
                      Asset Name *
                    </Typography>
                    <span>
                      <Tooltip placement="right" title={INFO.assetName}>
                        <Info
                          sx={{
                            fontSize: 16,
                            color: (theme) => theme.palette.grey[500],
                          }}
                        />
                      </Tooltip>
                    </span>
                  </Stack>
                  <TextField
                    autoComplete="off"
                    size="small"
                    error={Boolean(
                      formik.touched.assetName && formik.errors.assetName
                    )}
                    fullWidth
                    helperText={
                      formik.touched.assetName && formik.errors.assetName
                    }
                    placeholder="Type"
                    margin="normal"
                    sx={{ mt: "8px" }}
                    name="assetName"
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    value={formik.values.assetName}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <Stack direction="row" justifyContent="space-between">
                    <Typography fontSize={12} variant="h4" fontWeight="700">
                      Secondary Asset ID
                    </Typography>
                    <span>
                      <Tooltip placement="right" title={INFO.secondaryAssetID}>
                        <Info
                          sx={{
                            fontSize: 16,
                            color: (theme) => theme.palette.grey[500],
                          }}
                        />
                      </Tooltip>
                    </span>
                  </Stack>
                  <TextField
                    autoComplete="off"
                    size="small"
                    error={Boolean(
                      formik.touched.secondaryAssetID &&
                      formik.errors.secondaryAssetID
                    )}
                    fullWidth
                    helperText={
                      formik.touched.secondaryAssetID &&
                      formik.errors.secondaryAssetID
                    }
                    placeholder="Type"
                    margin="normal"
                    sx={{ mt: "8px" }}
                    name="secondaryAssetID"
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    value={formik.values.secondaryAssetID}
                  />
                </Grid>
                <Grid item xs={12} md={3}></Grid>
                <Grid item xs={12} md={6}>
                  <Stack direction="row" justifyContent="space-between">
                    <Typography fontSize={12} variant="h4" fontWeight="700">
                      Comments
                    </Typography>
                  </Stack>
                  <TextField
                    autoComplete="off"
                    size="small"
                    error={Boolean(
                      formik.touched.comments && formik.errors.comments
                    )}
                    fullWidth
                    helperText={
                      formik.touched.comments && formik.errors.comments
                    }
                    placeholder="Add a comment..."
                    margin="normal"
                    sx={{ mt: "8px" }}
                    name="comments"
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    value={formik.values.comments}
                    InputProps={{
                      inputComponent: TextareaAutosize,
                      inputProps: { minRows: 2 },
                    }}
                    variant="outlined"
                  />
                </Grid>
              </Grid>
              {/* <Divider sx={{ my: 2 }} /> */}
              {/* Issuance: */}
              {/* <Grid container spacing={2}>
                <Grid item xs={12} md={3}>
                  <Typography fontSize={18} variant="h4">
                    Issuance:
                  </Typography>
                </Grid>
                <Grid item xs={12} md={3}>
                  <Stack direction="row" justifyContent="space-between">
                    <Typography fontSize={12} variant="h4" fontWeight="700">
                      Issued To
                    </Typography>
                  </Stack>
                  <TextField
                    autoComplete="off"
                    disabled
                    size="small"
                    error={Boolean(
                      formik.touched.issuedTo && formik.errors.issuedTo
                    )}
                    fullWidth
                    helperText={
                      formik.touched.issuedTo && formik.errors.issuedTo
                    }
                    placeholder="Coming Soon"
                    margin="normal"
                    sx={{ mt: "8px" }}
                    name="issueTo"
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    value={formik.values.issuedTo}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <Stack direction="row" justifyContent="space-between">
                    <Typography fontSize={12} variant="h4" fontWeight="700">
                      Issued On
                    </Typography>
                  </Stack>
                  <TextField
                    disabled
                    autoComplete="off"
                    size="small"
                    error={Boolean(
                      formik.touched.issuedOn && formik.errors.issuedOn
                    )}
                    fullWidth
                    helperText={
                      formik.touched.issuedOn && formik.errors.issuedOn
                    }
                    placeholder="Coming Soon"
                    margin="normal"
                    sx={{ mt: "8px" }}
                    name="issueOn"
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    value={formik.values.issuedOn}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <Stack direction="row" justifyContent="space-between">
                    <Typography fontSize={12} variant="h4" fontWeight="700">
                      Return On
                    </Typography>
                  </Stack>
                  <TextField
                    disabled
                    autoComplete="off"
                    size="small"
                    error={Boolean(
                      formik.touched.returnOn && formik.errors.returnOn
                    )}
                    fullWidth
                    helperText={
                      formik.touched.returnOn && formik.errors.returnOn
                    }
                    placeholder="Coming Soon"
                    margin="normal"
                    sx={{ mt: "8px" }}
                    name="returnOn"
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    value={formik.values.returnOn}
                  />
                </Grid>
              </Grid> */}
            </Box>
          </DialogContent>
          <Divider />
          <DialogActions>
            <Box sx={{ display: "flex" }}>
              <div>
                <Button
                  sx={{ mr: 2 }}
                  color="primary"
                  variant="outlined"
                  size="large"
                  onClick={() => {
                    handleClose();
                  }}
                >
                  Cancel
                </Button>{" "}
                <Button
                  sx={{ mr: 2 }}
                  color="primary"
                  variant="contained"
                  size="large"
                  disabled={!(formik.isValid && formik.dirty && newCustomer)}
                  onClick={() => {
                    formik.handleSubmit();
                  }}
                >
                  Create Asset
                </Button>
              </div>
            </Box>
          </DialogActions>
        </>
        {toast.map((item, id) => {
          return (
            <Snackbar
              key={id}
              open={item.open}
              autoHideDuration={6000}
              onClose={() => {
                setToast(toast.filter((v, i) => i !== id));
              }}
            >
              <Alert
                onClose={() => {
                  setToast(toast.filter((v, i) => i !== id));
                }}
                severity={item.severity}
                sx={{ width: "100%" }}
                variant="filled"
              >
                {item.message}
              </Alert>
            </Snackbar>
          );
        })}
      </Dialog>
    </div>
  );
};
